<template>
  <div class="test">
    <div class="wrapper">
      <h2>Тестовое задание от ДОМ.РФ</h2>

      <div class="test-item">
        <div class="test-item__name">Проверка на палиндром</div>
        <p class="test-item__text">Нужно написать функцию, которая будет определять, является ли введенное палиндромом. На входе принимает один аргумент, строку. Возвращать функция должна true или false.</p>
        <div class="test-item__form">
          <form @submit="palindromeCheckFunc">
            <input title="Поле для строки" class="test-item__input" v-model="palindromeString">
            <button title="Проверить" class="test-item__submit">Проверить</button>
            <span class="test-item__result" v-show="palindromeResult">{{this.palindromeResult}}</span>
          </form>
        </div>
      </div>

      <div class="test-item">
        <div class="test-item__name">Вставить дефис в центр строки</div>
        <p class="test-item__text">Есть строка вида '123456'. Надо перевести в вид '123-456'.</p>
        <div class="test-item__form">
          <form @submit="dashFunc">
            <input title="Поле для строки" class="test-item__input" v-model="dashString">
            <button title="Добавить" class="test-item__submit">Добавить</button>
            <span class="test-item__result" v-show="dashResult">{{this.dashResult}}</span>
          </form>
        </div>
      </div>

      <div class="test-item">
        <div class="test-item__name">Преобразование числа</div>
        <p class="test-item__text">Есть число 5321233. Надо перевести его в миллион и округлить до десятых. То есть в вид "5,3 млн".</p>
        <div class="test-item__form">
          <form @submit="millionFunc">
            <input title="Поле для строки" class="test-item__input" v-model="millionString">
            <button title="Преобразовать" class="test-item__submit">Преобразовать</button>
            <span class="test-item__result" v-show="millionResult">{{this.millionResult}}</span>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Photos",
  data () {
    return {
      palindromeString: '',
      palindromeResult: '',
      dashString: '',
      dashResult: '',
      millionString: '',
      millionResult: ''
    }
  },
  methods: {
    palindromeCheckFunc (e) {
      e.preventDefault()
      this.palindromeResult = this.palindromeString.trim().length > 1 ?
        '' + (this.palindromeString.trim().replace(/[- .,:?!%]/g, '').toLowerCase() === this.palindromeString.trim().replace(/[- .,:?!%]/g, '').toLowerCase().split('').reverse().join('')) + '' :
        'Заполните поле'
    },
    dashFunc (e) {
      e.preventDefault()
      this.dashResult = this.dashString.trim().length > 1 ?
        this.dashString.trim().slice(0,-(this.dashString.length/2)) + '-' + this.dashString.slice(-(this.dashString.length/2)) :
        'Заполните поле, минимум 2 символа'
    },
    millionFunc (e) {
      e.preventDefault()
      this.millionResult = this.millionString.trim().length > 5 && !isNaN(this.millionString.trim()) ?
        (this.millionString.trim() / 1000000).toFixed(1).replace(".",",") + ' млн.' :
        'Введите число не меньше 100000'
    }
  }
}
</script>

<style lang="scss" scoped>
  .test {
    margin: 30px 0 0;
    position: relative;

    &-item {
      margin: 25px 0 0;
      font-size: 0;

      & + & {
        margin-top: 20px;
        padding: 20px 0 0;
        border-top: 1px solid #dddddd;

        @media screen and (min-width: 768px){
          margin-top: 40px;
          padding: 0;
          border: none;
        }
      }

      &__name {
        margin: 0 0 10px;
        @include font(15px, 18px, $color-dark-gray);
        font-weight: bold;
      }

      &__text {
        padding: 0 0 15px;
        font-size: 13px;

        @media screen and (min-width: 768px){
          font-size: 14px;
        }
      }

      &__input {
        display: block;
        height: 35px;
        padding: 0 10px;
        border: 1px solid $color-link;
        border-radius: 5px;
        @include font(14px, 18px, $color-dark-gray);

        @media screen and (min-width: 768px){
          display: inline-block;
          width: 200px;
        }
      }

      &__submit {
        display: block;
        height: 35px;
        margin: 10px 0 0;
        padding: 0 20px;
        border: 0;
        border-radius: 5px;
        background: $color-link;
        cursor: pointer;
        @include font(14px, 35px, #ffffff);

        @media screen and (min-width: 768px){
          display: inline-block;
          margin: 0 0 0 15px;
        }

        &:hover {
          background: $color-link-hover;
        }
      }

      &__result {
        display: block;
        margin: 15px 0 0;
        @include font(12px, 17px, $color-text);

        @media screen and (min-width: 768px){
          display: inline-block;
          margin: 0 0 0 25px;
          @include font(14px, 35px, $color-text);
        }
      }
    }
  }
</style>